import request from '@/utils/request'

// 获取权限
export function getMyMenus(data) {
    return request({
        url: '/public/menus',
        method: 'POST',
        data
    })
}
